export default {
  'pages.covenantDevice.mac': 'MAC 주소',
  'pages.admin.providerCard.config.grpcAddr': 'gRPC 주소',
  'pages.covenantDevice.cardTitle': '계약 디바이스 관리',
  'pages.admin.whitelist.mac': 'MAC 주소',
  'pages.covenantDevice.operations': '작업',
  'pages.covenantDevice.expireTime': '만료 시간',
  'pages.covenantDevice.updateTime': '업데이트 시간',
  'pages.unbindDevice.titleAdmin': '디바이스 해제 (관리자 권한 필요)',
  'pages.unbindDevice.inputPlaceholder': '디바이스 ID를 입력하세요',
  'pages.unbindDevice.unbind': '해제',
  'pages.unbindDevice.unbinding': '해제 중...',
  'pages.unbindDevice.success': '해제 성공',
  'pages.unbindDevice.fail': '해제 실패',
  'pages.layouts.userLayout.title': '관리 콘솔',
  'pages.login.accountLogin.tab': '계정 로그인',
  'pages.login.accountLogin.errorMessage':
    '잘못된 사용자명/비밀번호(admin/ant.design)',
  'pages.login.failure': '로그인 실패, 다시 시도해주세요!',
  'pages.login.success': '로그인 성공!',
  'pages.login.username.placeholder': '사용자명: admin 또는 user',
  'pages.login.username.required': '사용자명을 입력해주세요!',
  'pages.login.password.placeholder': '비밀번호: ant.design',
  'pages.login.password.required': '비밀번호를 입력해주세요!',
  'pages.login.phoneLogin.tab': '휴대폰 로그인',
  'pages.login.phoneLogin.errorMessage': '인증번호 오류',
  'pages.login.phoneNumber.placeholder': '휴대폰 번호',
  'pages.login.phoneNumber.required': '휴대폰 번호를 입력해주세요!',
  'pages.login.phoneNumber.invalid': '유효하지 않은 휴대폰 번호입니다!',
  'pages.login.captcha.placeholder': '인증번호',
  'pages.login.captcha.required': '인증번호를 입력해주세요!',
  'pages.login.phoneLogin.getVerificationCode': '인증번호 받기',
  'pages.getCaptchaSecondText': '초',
  'pages.login.rememberMe': '로그인 상태 유지',
  'pages.login.forgotPassword': '비밀번호를 잊으셨나요?',
  'pages.login.submit': '로그인',
  'pages.login.loginWith': '로그인 방법:',
  'pages.login.registerAccount': '계정 등록',
  'pages.welcome.link': '환영합니다',
  'pages.welcome.alertMessage':
    '더 빠르고 강력한 헤비듀티 컴포넌트가 출시되었습니다.',
  'pages.404.subTitle': '죄송합니다. 방문하신 페이지가 존재하지 않습니다.',
  'pages.404.buttonText': '홈으로 돌아가기',
  'pages.admin.subPage.title': '이 페이지는 관리자만 볼 수 있습니다',
  'pages.admin.subPage.alertMessage':
    'Umi ui가 출시되었습니다. npm run ui를 사용하여 체험을 시작하세요.',
  'pages.searchTable.createForm.newRule': '새 규칙',
  'pages.searchTable.updateForm.ruleConfig': '규칙 구성',
  'pages.searchTable.updateForm.basicConfig': '기본 정보',
  'pages.searchTable.updateForm.ruleName.nameLabel': '규칙 이름',
  'pages.searchTable.updateForm.ruleName.nameRules':
    '규칙 이름을 입력해주세요!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '규칙 설명',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '최소 5글자를 입력해주세요',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '최소 5글자의 규칙 설명을 입력해주세요!',
  'pages.searchTable.updateForm.ruleProps.title': '속성 구성',
  'pages.searchTable.updateForm.object': '모니터링 객체',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '규칙 템플릿',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '규칙 유형',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    '스케줄링 기간 설정',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '시작 시간',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '시작 시간을 선택해주세요!',
  'pages.searchTable.titleDesc': '설명',
  'pages.searchTable.ruleName': '규칙 이름이 필요합니다',
  'pages.searchTable.titleCallNo': '서비스 호출 수',
  'pages.searchTable.titleStatus': '상태',
  'pages.searchTable.nameStatus.default': '기본값',
  'pages.searchTable.nameStatus.running': '실행 중',
  'pages.searchTable.nameStatus.online': '온라인',
  'pages.searchTable.nameStatus.abnormal': '비정상',
  'pages.searchTable.titleUpdatedAt': '마지막 스케줄링',
  'pages.searchTable.exception': '예외 사유를 입력해주세요!',
  'pages.searchTable.titleOption': '옵션',
  'pages.searchTable.config': '구성',
  'pages.searchTable.subscribeAlert': '알림 구독',
  'pages.searchTable.title': '조회 폼',
  'pages.searchTable.new': '새로 만들기',
  'pages.searchTable.chosen': '선택됨',
  'pages.searchTable.item': '항목',
  'pages.searchTable.totalServiceCalls': '총 서비스 호출 수',
  'pages.searchTable.tenThousand': '만',
  'pages.searchTable.batchDeletion': '일괄 삭제',
  'pages.searchTable.batchApproval': '일괄 승인',
  
  // Agents page related text
  'pages.agents.search.placeholder': '에이전트 검색',
  'pages.agents.create.button': '에이전트 생성',
  'pages.agents.addDevice.button': '디바이스 추가',
  'pages.agents.create.modal.title': '에이전트 생성',
  'pages.agents.create.modal.nameLabel': '에이전트 이름',
  'pages.agents.create.modal.placeholder': '에이전트 이름을 입력해주세요',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': '음성 모델',
  'pages.agents.card.languageModel': '언어 모델',
  'pages.agents.card.lastChat': '마지막 채팅',
  'pages.agents.card.conversationId': '대화 ID',
  'pages.agents.card.clearConversation': '대화 ID 지우기',
  'pages.agents.card.clearConversation.success': '대화 ID가 지워졌습니다',
  'pages.agents.card.clearConversation.error': '대화 ID 지우기에 실패했습니다',
  'pages.agents.card.configRole': '역할 구성',
  'pages.agents.card.voiceRecognition': '음성 인식',
  'pages.agents.card.voiceRecognition.developing': '기능 개발 중입니다. 기대해 주세요',
  'pages.agents.card.historyDialog': '히스토리 대화',
  'pages.agents.card.manageDevice': '디바이스 관리',
  'pages.agents.card.addDevice': '디바이스 추가',
  'pages.agents.loading': '에이전트 목록 로딩 중...',
  'pages.agents.reload': '다시 로드',
  'pages.agents.empty.title': '사용 가능한 에이전트가 없습니다',
  'pages.agents.empty.createFirst': '첫 번째 에이전트를 생성하세요',
  'pages.agents.delete.title': '에이전트 삭제 확인',
  'pages.agents.delete.content': '에이전트를 삭제하면 모든 관련 구성(디바이스 관련 대화 기록 포함)을 복구할 수 없습니다. 정말 삭제하시겠습니까?',
  'pages.agents.delete.confirm': '삭제 확인',
  'pages.agents.fetch.error': '에이전트 목록 가져오기 실패',
  'pages.agents.network.error': '네트워크 오류, 나중에 다시 시도해주세요',
  'pages.agents.speed.patient': '느리게',
  'pages.agents.speed.normal': '보통',
  'pages.agents.speed.fast': '빠르게',
  'pages.agents.lastChat.none': '없음',
  'pages.agents.language.chinese': '중국어',
  'pages.agents.loading.tts.error': 'TTS 음성 로드 실패',
  'pages.agents.loading.llm.error': 'LLM 공급자 로드 실패',
  'pages.agents.sort.id': 'ID로 정렬',
  'pages.agents.sort.updatedAt': '최종 수정으로 정렬',
  'pages.agents.sort.lastConversationAt': '최종 대화로 정렬',
  
  // Register page related text
  'pages.register': '등록',
  'pages.register.title': '등록',
  'pages.register.form.title': '새 계정 등록',
  'pages.register.submit': '등록',
  'pages.register.username.placeholder': '사용자명을 입력해주세요',
  'pages.register.username.required': '사용자명을 입력해주세요!',
  'pages.register.username.min': '사용자명은 최소 4글자여야 합니다',
  'pages.register.email.placeholder': '이메일을 입력해주세요',
  'pages.register.email.required': '이메일을 입력해주세요!',
  'pages.register.email.invalid': '유효한 이메일 주소를 입력해주세요!',
  'pages.register.password.placeholder': '비밀번호를 입력해주세요',
  'pages.register.password.required': '비밀번호를 입력해주세요!',
  'pages.register.password.min': '비밀번호는 최소 6글자여야 합니다',
  'pages.register.password.pattern': '비밀번호는 대문자, 소문자, 숫자를 포함해야 합니다',
  'pages.register.confirmPassword.placeholder': '비밀번호를 확인해주세요',
  'pages.register.confirmPassword.required': '비밀번호를 확인해주세요!',
  'pages.register.confirmPassword.min': '비밀번호는 최소 6글자여야 합니다',
  'pages.register.error.passwordMismatch': '두 비밀번호가 일치하지 않습니다',
  'pages.register.error.registerFailed': '등록 실패, 다시 시도해주세요!',
  'pages.register.success': '등록 성공!',
  
  // Login page related text
  'pages.login.title': '애니메 AI 채팅 관리 콘솔',
  'pages.login.actionIcons.notImplemented': '아직 구현되지 않았습니다. 곧 출시됩니다',
  'pages.login.mobile.captchaError': '인증번호 오류',
  'pages.login.captcha.success': '인증번호 전송 성공! 번호: 1234',
  'pages.login.forgotPassword.contactAdmin': '관리자에게 문의하세요',
  'pages.login.mobile.notAvailable': '이 기능은 아직 사용할 수 없습니다. 계정 로그인을 사용해주세요',
  
  // AgentSetting page related text
  'pages.agentSetting.title': '역할 구성',
  'pages.agentSetting.back': '돌아가기',
  'pages.agentSetting.roleTemplate.title': '역할 템플릿',
  'pages.agentSetting.roleTemplate.label': '템플릿',
  'pages.agentSetting.template.taiwanGirlfriend': '대만 여자친구',
  'pages.agentSetting.template.potato': '포테이토',
  'pages.agentSetting.template.englishTutor': '영어 튜터',
  'pages.agentSetting.template.curiousBoy': '호기심 많은 소년',
  'pages.agentSetting.template.puppyLeader': '강아지 리더',
  'pages.agentSetting.basicConfig.title': '기본 구성',
  'pages.agentSetting.assistantName.label': '어시스턴트 이름',
  'pages.agentSetting.assistantName.placeholder': '어시스턴트 이름을 입력해주세요',
  'pages.agentSetting.assistantName.required': '어시스턴트 이름을 입력해주세요',
  'pages.agentSetting.dialogLanguage.label': '대화 언어',
  'pages.agentSetting.dialogLanguage.placeholder': '대화 언어를 선택하세요',
  'pages.agentSetting.voiceType.label': '음성 유형',
  'pages.agentSetting.voiceType.placeholder': '음성 유형을 선택하세요',
  'pages.agentSetting.roleDescription.title': '역할 설명',
  'pages.agentSetting.roleDescription.label': '역할 설명',
  'pages.agentSetting.roleDescription.placeholder': '역할 설명을 입력해주세요',
  'pages.agentSetting.roleDescription.required': '역할 설명을 입력해주세요',
  'pages.agentSetting.languageModel.title': '언어 모델',
  'pages.agentSetting.languageModel.label': '언어 모델',
  'pages.agentSetting.languageModel.placeholder': '언어 모델을 선택하세요',
  'pages.agentSetting.languageModel.tip': '모델을 변경한 후에는 채팅 경험에 영향을 주지 않도록 메모리를 지우는 것을 권장합니다.',
  'pages.agentSetting.advancedSettings.expand': '고급 설정 펼치기',
  'pages.agentSetting.advancedSettings.collapse': '고급 설정 접기',
  'pages.agentSetting.recognitionSpeed.label': '음성 인식 속도',
  'pages.agentSetting.recognitionSpeed.placeholder': '인식 속도를 선택하세요',
  'pages.agentSetting.speechSpeed.label': '음성 속도',
  'pages.agentSetting.speechSpeed.placeholder': '음성 속도를 선택하세요',
  'pages.agentSetting.pitchValue.label': '캐릭터 볼륨',
  'pages.agentSetting.button.reset': '재설정',
  'pages.agentSetting.button.save': '저장',
  'pages.agentSetting.save.success': '저장 성공',
  'pages.agentSetting.save.error': '저장 실패',
  'pages.agentSetting.save.missingId': '에이전트 ID 누락, 저장할 수 없습니다',
  'pages.agentSetting.load.tts.error': 'TTS 음성 로드 실패',
  'pages.agentSetting.speed.slow': '느림',
  'pages.agentSetting.speed.normal': '보통',
  'pages.agentSetting.speed.fast': '빠름',
  'pages.agentSetting.speed.patient': '느리게',
  'pages.agentSetting.language.chinese': '중국어',
  'pages.agentSetting.language.english': '영어',
  'pages.agentSetting.language.spanish': '스페인어',
  'pages.agentSetting.language.french': '프랑스어',
  'pages.agentSetting.language.german': '독일어',
  'pages.agentSetting.language.japanese': '일본어',
  'pages.agentSetting.language.korean': '한국어',
  'pages.agentSetting.language.portuguese': '포르투갈어',
  'pages.agentSetting.language.arabic': '아랍어',
  'pages.agentSetting.language.russian': '러시아어',
  'pages.agentSetting.language.italian': '이탈리아어',
  'pages.agentSetting.language.turkish': '터키어',
  'pages.agentSetting.language.polish': '폴란드어',
  'pages.agentSetting.language.catalan': '카탈란어',
  

  // DeviceManagement page related text
  'pages.devices.title': '디바이스 관리',
  'pages.devices.breadcrumb.agents': '에이전트',
  'pages.devices.breadcrumb.devices': '디바이스 관리',
  'pages.devices.button.addDevice': '디바이스 추가',
  'pages.devices.warning.noAgentId': 'agentId가 지정되지 않아 디바이스 목록을 가져올 수 없습니다',
  'pages.devices.device.unnamed': '이름 없는 디바이스',
  'pages.devices.device.macAddress': 'MAC 주소',
  'pages.devices.device.lastActive': '마지막 활성',
  'pages.devices.device.firmwareVersion': '펌웨어 버전',
  'pages.devices.device.otaUpgrade': 'OTA 업그레이드',
  'pages.devices.device.noData': '데이터 없음',
  'pages.devices.copy.success': 'MAC 주소가 복사되었습니다',
  'pages.devices.unbind.title': '디바이스 해제 확인',
  'pages.devices.unbind.content': '디바이스 해제는 복구할 수 없습니다. 다시 사용하려면 재바인딩해야 합니다. 정말 해제하시겠습니까?',
  'pages.devices.unbind.confirm': '해제 확인',
  'pages.devices.unbind.cancel': '취소',
  'pages.devices.unbind.success': '디바이스가 해제되었습니다',
  'pages.devices.unbind.error': '해제 실패',
  'pages.devices.ota.enabled': 'OTA 업그레이드 활성화됨',
  'pages.devices.ota.disabled': 'OTA 업그레이드 비활성화됨',
  
  // HistoryDialogs page related text
  'pages.historyDialogs.title': '히스토리 대화',
  'pages.historyDialogs.breadcrumb.agents': '에이전트',
  'pages.historyDialogs.breadcrumb.historyDialogs': '히스토리 대화',
  'pages.historyDialogs.empty.title': '선택된 대화가 없습니다',
  'pages.historyDialogs.empty.description': '대화를 선택해주세요',
  'pages.historyDialogs.agent': '에이전트',
  'pages.historyDialogs.agent.id': 'id',
  'pages.historyDialogs.conversationDetail': '대화 세부사항',
  'pages.historyDialogs.selectConversation': '대화를 선택해주세요',
  'pages.historyDialogs.delete.title': '대화 삭제',
  'pages.historyDialogs.delete.content': '삭제 후 대화를 복구할 수 없습니다. 작업을 확인해주세요.',
  'pages.historyDialogs.delete.confirm': '확인',
  'pages.historyDialogs.delete.cancel': '취소',
  'pages.historyDialogs.message.delete.confirm': '이 메시지를 삭제하시겠습니까? 삭제 후 복구할 수 없습니다.',
  'pages.historyDialogs.detail.title': '대화 세부사항',
  'pages.historyDialogs.agent.label': '에이전트:',
  'pages.historyDialogs.user.label': '사용자:',
  'pages.historyDialogs.loading': '로딩 중...',
  'pages.historyDialogs.error.loadFailed': '대화 목록 로드 실패',
  'pages.historyDialogs.error.deleteFailed': '대화 삭제 실패',
  'pages.historyDialogs.success.deleteSuccess': '대화가 성공적으로 삭제되었습니다',
  
  // MessageList page related text
  'pages.messageList.empty': '메시지가 없습니다',
  'pages.messageList.user': '사용자',
  'pages.messageList.ai': 'AI',
  
  // Settings page related text
  'pages.settings.basicInfo.title': '기본 정보',
  'pages.settings.avatar.label': '아바타:',
  'pages.settings.avatar.change': '아바타 변경',
  'pages.settings.avatar.updateSuccess': '아바타가 성공적으로 업데이트되었습니다',
  'pages.settings.avatar.updateFailed': '아바타 업데이트에 실패했습니다',
  'pages.settings.username.label': '사용자명:',
  'pages.settings.nickname.label': '닉네임:',
  'pages.settings.nickname.change': '닉네임 편집',
  'pages.settings.nickname.modal.title': '닉네임 편집',
  'pages.settings.nickname.form.label': '새 닉네임',
  'pages.settings.nickname.form.required': '새 닉네임을 입력해주세요',
  'pages.settings.nickname.form.length': '닉네임 길이는 2-20자여야 합니다',
  'pages.settings.nickname.updateSuccess': '닉네임이 성공적으로 업데이트되었습니다',
  'pages.settings.nickname.updateFailed': '닉네임 업데이트에 실패했습니다',
  'pages.settings.registerTime.label': '등록 시간:',
  'pages.settings.email.label': '이메일:',
  'pages.settings.email.unbind': '연결되지 않음',
  'pages.settings.email.bind': '이메일 연결',
  'pages.settings.email.change': '이메일 변경',
  'pages.settings.email.modal.title': '이메일 연결',
  'pages.settings.email.modal.changeTitle': '이메일 변경',
  'pages.settings.email.form.label': '이메일',
  'pages.settings.email.form.required': '이메일을 입력해주세요',
  'pages.settings.email.form.invalid': '유효하지 않은 이메일 형식입니다',
  'pages.settings.email.bindSuccess': '이메일이 성공적으로 연결되었습니다',
  'pages.settings.email.bindFailed': '이메일 연결에 실패했습니다',
  'pages.settings.changePassword.title': '비밀번호 변경',
  'pages.settings.changePassword.button': '비밀번호 변경',
  'pages.settings.changePassword.modal.title': '비밀번호 변경',
  'pages.settings.changePassword.oldPassword.label': '기존 비밀번호',
  'pages.settings.changePassword.oldPassword.required': '기존 비밀번호를 입력해주세요',
  'pages.settings.changePassword.newPassword.label': '새 비밀번호',
  'pages.settings.changePassword.newPassword.required': '새 비밀번호를 입력해주세요',
  'pages.settings.changePassword.newPassword.min': '새 비밀번호는 최소 6글자여야 합니다',
  'pages.settings.changePassword.confirmPassword.label': '새 비밀번호 확인',
  'pages.settings.changePassword.confirmPassword.required': '새 비밀번호를 확인해주세요',
  'pages.settings.changePassword.confirmPassword.mismatch': '비밀번호가 일치하지 않습니다',
  'pages.settings.changePassword.success': '비밀번호가 성공적으로 변경되었습니다',
  'pages.settings.changePassword.failed': '비밀번호 변경에 실패했습니다',
  'pages.settings.deleteAccount.title': '계정 삭제',
  'pages.settings.deleteAccount.button': '계정 삭제',
  'pages.settings.deleteAccount.confirm.title': '계정 삭제를 확인하시겠습니까?',
  'pages.settings.deleteAccount.confirm.content': '이 작업은 되돌릴 수 없습니다. 정말 계정을 삭제하시겠습니까?',
  'pages.settings.deleteAccount.confirm.ok': '삭제',
  'pages.settings.deleteAccount.confirm.cancel': '취소',
  'pages.settings.deleteAccount.success': '계정이 성공적으로 삭제되었습니다',
  'pages.settings.deleteAccount.failed': '계정 삭제에 실패했습니다',
  'pages.settings.profile.fetchFailed': '사용자 정보 가져오기에 실패했습니다',
  'pages.settings.form.submit': '제출',
  'pages.settings.password.title': '비밀번호 설정',
  'pages.settings.basicInfo.username': '사용자명',
  'pages.settings.basicInfo.nickname': '닉네임',
  'pages.settings.basicInfo.avatar': '아바타',
  'pages.settings.basicInfo.editNickname': '닉네임 편집',
  'pages.settings.basicInfo.editNicknameTitle': '닉네임 편집',
  'pages.settings.basicInfo.newNicknameLabel': '새 닉네임',
  'pages.settings.basicInfo.nicknameChangeSuccess': '닉네임이 성공적으로 변경되었습니다',
  'pages.settings.basicInfo.openId': 'OpenID:',
  'pages.settings.submit': '제출',
  'pages.settings.deleteAccount.confirmTitle': '계정 삭제 확인',
  'pages.settings.deleteAccount.confirmContent': '계정을 삭제하면 모든 데이터가 영구적으로 삭제되고 복구할 수 없으며, 더 이상 이 계정으로 로그인할 수 없습니다. 신중하게 진행하세요!',
  'pages.settings.deleteAccount.cancel': '취소',
  'pages.settings.deleteAccount.confirm': '삭제 확인',
  
  // Admin Dashboard
  'pages.admin.dashboard.userCount': '사용자 수',
  'pages.admin.dashboard.deviceCount': '디바이스 수', 
  'pages.admin.dashboard.agentCount': '에이전트 수',
  'pages.admin.dashboard.onlineUsers': '온라인 사용자',
  'pages.admin.dashboard.sessionDevices': '세션 디바이스',
  'pages.admin.dashboard.memoryUsage': '메모리 사용량',
  'pages.admin.dashboard.cpuUsage': 'CPU 사용량',
  'pages.admin.dashboard.fetchError': '데이터 가져오기 실패',
  'pages.admin.dashboard.networkError': '네트워크 오류',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': '사용자명',
  'pages.admin.user.email': '이메일',
  'pages.admin.user.status': '상태',
  'pages.admin.user.status.all': '전체',
  'pages.admin.user.status.disabled': '비활성화됨',
  'pages.admin.user.status.normal': '정상',
  'pages.admin.user.quotaUsed': '일일 할당량 사용',
  'pages.admin.user.quotaTotal': '일일 할당량 총량',
  'pages.admin.user.createdAt': '생성일',
  'pages.admin.user.operations': '작업',
  'pages.admin.user.edit': '편집',
  'pages.admin.user.detail': '세부사항',
  'pages.admin.user.editModal.title': '사용자 편집',
  'pages.admin.user.status.label': '사용자 상태',
  'pages.admin.user.status.enable': '활성화',
  'pages.admin.user.status.disable': '비활성화',
  'pages.admin.user.quotaUsed.label': '일일 할당량 사용',
  'pages.admin.user.quotaTotal.label': '일일 할당량 총량',
  'pages.admin.user.email.label': '이메일',
  'pages.admin.user.save.success': '저장 성공',
  'pages.admin.user.save.failed': '저장 실패',
  'pages.admin.user.list.title': '사용자 목록',

  // Admin Model Providers
  'pages.admin.providers.title': '모델 공급자 관리',
  'pages.admin.providers.total': '총 {total}개 공급자',
  'pages.admin.providers.stats': 'ASR: {asr}, TTS: {tts}, LLM: {llm}, VLLLM: {vlllm}',
  'pages.admin.providers.addNew': '새 공급자 추가',
  'pages.admin.providers.search.placeholder': '공급자 이름, 엔드포인트 또는 모델 검색...',
  'pages.admin.providers.filter.all': '모든 유형',
  'pages.admin.providers.filter.asr': 'ASR - 음성 인식',
  'pages.admin.providers.filter.tts': 'TTS - 텍스트 음성 변환', 
  'pages.admin.providers.filter.llm': 'LLM - 대규모 언어 모델',
  'pages.admin.providers.filter.vlllm': 'VLLLM - 비전 언어 모델',
  'pages.admin.providers.empty.noProviders': '아직 공급자가 없습니다',
  'pages.admin.providers.empty.noMatches': '일치하는 공급자를 찾을 수 없습니다',
  'pages.admin.providers.empty.addFirst': '위 버튼을 클릭하여 첫 번째 모델 공급자를 추가하세요',
  'pages.admin.providers.empty.adjustFilters': '검색 조건이나 필터를 조정해보세요',
  'pages.admin.providers.type.asr': 'ASR - 음성 인식',
  'pages.admin.providers.type.tts': 'TTS - 텍스트 음성 변환',
  'pages.admin.providers.type.llm': 'LLM - 대규모 언어 모델',
  'pages.admin.providers.type.vlllm': 'VLLLM - 비전 언어 모델',
  'pages.admin.providers.success.created': '공급자가 성공적으로 추가되었습니다!',
  'pages.admin.providers.success.updated': '공급자가 성공적으로 업데이트되었습니다!',
  'pages.admin.providers.success.deleted': '공급자가 성공적으로 삭제되었습니다!',
  'pages.admin.providers.success.statusToggled': '상태가 성공적으로 전환되었습니다!',
  'pages.admin.providers.error.createFailed': '공급자 추가 실패, 다시 시도해주세요',
  'pages.admin.providers.error.updateFailed': '공급자 업데이트 실패, 다시 시도해주세요',
  'pages.admin.providers.error.deleteFailed': '공급자 삭제 실패, 다시 시도해주세요',
  'pages.admin.providers.error.testFailed': '연결 테스트 실패, 네트워크나 구성을 확인해주세요',
  'pages.admin.providers.error.toggleFailed': '상태 전환 실패, 다시 시도해주세요',
  'pages.admin.providers.error.loadFailed': '공급자 목록 로드 실패, 페이지를 새로 고침해주세요',

  // Admin Settings
  'pages.admin.settings.title': '시스템 설정',
  'pages.admin.settings.asr.label': 'ASR 서비스',
  'pages.admin.settings.asr.placeholder': 'ASR 서비스 선택',
  'pages.admin.settings.tts.label': 'TTS 서비스',
  'pages.admin.settings.tts.placeholder': 'TTS 서비스 선택',
  'pages.admin.settings.llm.label': 'LLM 서비스',
  'pages.admin.settings.llm.placeholder': 'LLM 서비스 선택',
  'pages.admin.settings.vlllm.label': 'VLLLM 서비스',
  'pages.admin.settings.vlllm.placeholder': 'VLLLM 서비스 선택',
  'pages.admin.settings.prompt.label': '프롬프트 설정',
  'pages.admin.settings.prompt.placeholder': '시스템 프롬프트를 입력해주세요...',
  'pages.admin.settings.quickReply.label': '빠른 답변 단어',
  'pages.admin.settings.quickReply.placeholder': '새 빠른 답변 단어 입력',
  'pages.admin.settings.quickReply.add': '추가',
  'pages.admin.settings.deleteAudio.label': '오디오 삭제',
  'pages.admin.settings.deleteAudio.enabled': '활성화됨',
  'pages.admin.settings.deleteAudio.disabled': '비활성화됨',
  'pages.admin.settings.usePrivateConfig': '프라이빗 설정 사용',
  'pages.admin.settings.save': '구성 저장',
  'pages.admin.settings.saving': '저장 중...',
  'pages.admin.settings.reset': '재설정',
  'pages.admin.settings.success.saved': '구성이 성공적으로 저장되었습니다!',
  'pages.admin.settings.error.saveFailed': '구성 저장 실패, 다시 시도해주세요',
  'pages.admin.settings.error.loadFailed': '구성 로드 실패, 페이지를 새로 고침하고 다시 시도해주세요',


  // Add Device Dialog
  'pages.addDevice.modal.title': '디바이스 추가',
  'pages.addDevice.verificationCode.label': '인증번호:',
  'pages.addDevice.verificationCode.placeholder': '디바이스의 6자리 인증번호를 입력해주세요',
  'pages.addDevice.verificationCode.required': '6자리 인증번호를 입력해주세요',
  'pages.addDevice.verificationCode.error': '6자리 인증번호를 입력해주세요',

  // Provider Modal
  'pages.admin.providerModal.edit.title': '공급자 편집',
  'pages.admin.providerModal.add.title': '새 공급자 추가',
  'pages.admin.providerModal.name.label': '공급자 이름 *',
  'pages.admin.providerModal.name.placeholder': '예: OpenAI, Doubao TTS',
  'pages.admin.providerModal.name.required': '공급자 이름을 입력해주세요',
  'pages.admin.providerModal.type.label': '서비스 카테고리 *',
  'pages.admin.providerModal.subType.label': '구체적인 유형 *',
  'pages.admin.providerModal.subType.required': '구체적인 유형을 선택해주세요',
  'pages.admin.providerModal.config.title': '구성',
  'pages.admin.providerModal.api.url.label': 'API URL *',
  'pages.admin.providerModal.api.url.required': 'API URL을 입력해주세요',
  'pages.admin.providerModal.model.name.label': '모델 이름 *',
  'pages.admin.providerModal.model.name.required': '모델 이름을 입력해주세요',
  'pages.admin.providerModal.api.key.label': 'API 키 *',
  'pages.admin.providerModal.api.key.required': 'API 키를 입력해주세요',
  'pages.admin.providerModal.temperature.label': '온도 (0-2)',
  'pages.admin.providerModal.temperature.error': '온도는 0-2 사이여야 합니다',
  'pages.admin.providerModal.maxTokens.label': '최대 토큰',
  'pages.admin.providerModal.maxTokens.error': '최대 토큰은 1-32768 사이여야 합니다',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': '앱 ID *',
  'pages.admin.providerModal.appid.required': '앱 ID를 입력해주세요',
  'pages.admin.providerModal.accessToken.label': '액세스 토큰 *',
  'pages.admin.providerModal.accessToken.required': '액세스 토큰을 입력해주세요',
  'pages.admin.providerModal.cluster.label': '클러스터',
  'pages.admin.providerModal.grpc.host.label': 'gRPC 호스트 *',
  'pages.admin.providerModal.grpc.host.required': 'gRPC 호스트 주소를 입력해주세요',
  'pages.admin.providerModal.grpc.port.label': 'gRPC 포트 *',
  'pages.admin.providerModal.grpc.port.required': 'gRPC 포트를 입력해주세요',
  'pages.admin.providerModal.voice.label': '음성 *',
  'pages.admin.providerModal.voice.required': '음성 유형을 입력해주세요',
  'pages.admin.providerModal.token.label': '토큰 *',
  'pages.admin.providerModal.token.required': '토큰을 입력해주세요',
  'pages.admin.providerModal.websocket.label': 'WebSocket URL *',
  'pages.admin.providerModal.websocket.required': 'WebSocket URL을 입력해주세요',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'API 키 *',
  'pages.admin.providerModal.siliconflow.apiKey.required': 'API 키를 입력해주세요',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'API URL',
  'pages.admin.providerModal.manage.voices': '음성 관리',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTS는 추가 구성이 필요하지 않습니다',
  'pages.admin.providerModal.submit.error': '제출 실패, 다시 시도해주세요',

  // Provider Card
  'pages.admin.providerCard.status.active': '활성',
  'pages.admin.providerCard.status.inactive': '오프라인',
  'pages.admin.providerCard.status.error': '오류',
  'pages.admin.providerCard.status.unknown': '알 수 없음',
  'pages.admin.providerCard.warning.readonly.test': '읽기 전용 권한으로 공급자를 테스트할 수 없습니다',
  'pages.admin.providerCard.warning.readonly.delete': '읽기 전용 권한으로 공급자를 삭제할 수 없습니다',
  'pages.admin.providerCard.warning.readonly.edit': '읽기 전용 권한으로 공급자를 편집할 수 없습니다',
  'pages.admin.providerCard.warning.readonly.toggle': '읽기 전용 권한으로 상태를 전환할 수 없습니다',
  'pages.admin.providerCard.button.disable': '비활성화',
  'pages.admin.providerCard.button.enable': '활성화',
  'pages.admin.providerCard.button.testing': '테스트 중...',
  'pages.admin.providerCard.button.test': '테스트',
  'pages.admin.providerCard.button.edit': '편집',
  'pages.admin.providerCard.button.delete': '삭제',
  'pages.admin.providerCard.delete.title': '이 항목을 삭제하시겠습니까?',
  'pages.admin.providerCard.delete.content': '삭제 후 복구할 수 없습니다. 작업을 확인해주세요.',
  'pages.admin.providerCard.config.type': '유형',
  'pages.admin.providerCard.config.apiUrl': 'API URL',
  'pages.admin.providerCard.config.model': '모델',
  'pages.admin.providerCard.config.apiKey': 'API 키',
  'pages.admin.providerCard.config.temperature': '온도',
  'pages.admin.providerCard.config.maxTokens': '최대 토큰',
  'pages.admin.providerCard.config.appid': '앱 ID',
  'pages.admin.providerCard.config.cluster': '클러스터',
  'pages.admin.providerCard.config.accessToken': '액세스 토큰',
  'pages.admin.providerCard.config.grpcHost': 'gRPC 호스트',
  'pages.admin.providerCard.config.grpcPort': 'gRPC 포트',
  'pages.admin.providerCard.config.voice': '음성',
  'pages.admin.providerCard.config.format': '형식',
  'pages.admin.providerCard.config.token': '토큰',
  'pages.admin.providerCard.config.outputDir': '출력 디렉토리',
  'pages.admin.providerCard.voices.supported': '지원되는 음성',
  'pages.admin.providerCard.voices.count': '',
  'pages.admin.providerCard.test.failed': '테스트 실패',

    // OpsManage
  'pages.admin.ops.service.title': '서비스 관리',
  'pages.admin.ops.upload.button': '서비스 파일 업로드',
  'pages.admin.ops.upload.success': '서비스 파일이 성공적으로 업로드되었습니다',
  'pages.admin.ops.upload.error': '서비스 파일 업로드 실패',
  'pages.admin.ops.restart.button': '서비스 재시작',
  'pages.admin.ops.restart.confirmTitle': '주의: 서비스를 재시작하시겠습니까?',
  'pages.admin.ops.restart.desc': '서비스를 재시작하면 모든 현재 연결이 끊어지고 서비스가 일시적으로 사용할 수 없게 됩니다.',
  'pages.admin.ops.restart.warn': '이 작업은 현재 서비스 프로세스만 중지합니다. 서버에 데몬이나 자동 재시작 스크립트가 구성되어 있는지 확인하세요. 그렇지 않으면 서비스가 자동으로 복구되지 않습니다!',
  'pages.admin.ops.restart.ok': '재시작 확인',
  'pages.admin.ops.restart.cancel': '취소',
  'pages.admin.ops.restart.success': '서비스 재시작 명령이 전송되었습니다',
  'pages.admin.ops.restart.error': '서비스 재시작 실패',
  'pages.admin.ops.log.title': '로그 보기 및 다운로드',
  'pages.admin.ops.web.upload.button': 'web.zip 업로드',
  'pages.admin.ops.web.upload.success': 'web.zip이 성공적으로 업로드되었습니다',
  'pages.admin.ops.web.upload.error': 'web.zip 업로드 실패',
  'pages.admin.ops.web.upload.onlyzip': 'zip 파일만 허용됩니다',
  'pages.admin.ops.web.update.button': '웹 디렉토리 업데이트',
  'pages.admin.ops.web.update.success': '웹 디렉토리 업데이트 명령이 전송되었습니다',
  'pages.admin.ops.web.update.error': '웹 디렉토리 업데이트 실패',
  'pages.admin.ops.web.upload.onlywebzip': 'web.zip이라는 이름의 파일만 허용됩니다',

  // Recorder Management
  'pages.admin.recorder.title': '디바이스 레코더 관리',
  'pages.admin.recorder.inputDeviceId': '디바이스 ID를 입력해주세요',
  'pages.admin.recorder.inputPlaceholder': '디바이스 ID를 입력해주세요',
  'pages.admin.recorder.search': '검색',
  'pages.admin.recorder.list.title': '레코더 목록',
  'pages.admin.recorder.fetchSuccess': '레코더 기록을 성공적으로 가져왔습니다',
  'pages.admin.recorder.fetchError': '레코더 목록 가져오기 실패',
  'pages.admin.recorder.empty': '레코더 데이터가 없습니다. 디바이스 ID를 입력하여 검색하세요',
  'pages.admin.recorder.totalCount': '통계',
  'pages.admin.recorder.conversationId': '대화 ID',

  'pages.unbindDevice.cardTitle': '디바이스 언바인딩',
  'pages.whiteList.cardTitle': '화이트리스트 관리',
  'pages.admin.ops.logViewer.previewTitle': '로그 미리보기',
  'pages.admin.ops.logViewer.fileName': '파일 이름：',
  'pages.admin.ops.logViewer.lineCount': '줄 수：',
  'pages.admin.ops.logViewer.previewBtn': '미리보기',
  'pages.admin.ops.logViewer.noContent': '로그가 없습니다',

  'pages.agentSetting.mcp.modal.title': 'MCP 엔드포인트 설정',
  'pages.agentSetting.mcp.modal.statusLabel': '엔드포인트 상태',
  'pages.agentSetting.mcp.modal.online': '온라인',
  'pages.agentSetting.mcp.modal.disconnected': '연결 끊김',
  'pages.agentSetting.mcp.modal.unknown': '알 수 없음',
  'pages.agentSetting.mcp.modal.refresh': '새로 고침',
  'pages.agentSetting.mcp.modal.enabledServices': '활성화된 서비스',
  'pages.agentSetting.mcp.modal.endpointLabel': '엔드포인트 주소',
  'pages.agentSetting.mcp.modal.endpointDesc': '아래는 에이전트의 MCP 엔드포인트 주소입니다.',
  'pages.agentSetting.mcp.modal.docLink': '엔드포인트 문서 보기',
  'pages.agentSetting.mcp.modal.noEndpoint': '사용 가능한 엔드포인트가 없습니다',
  'pages.agentSetting.mcp.modal.hide': '숨기기',
  'pages.agentSetting.mcp.title': 'MCP 설정', 
  'pages.agentSetting.mcp.customService': '사용자 정의 서비스',
  'pages.agentSetting.mcp.officialServices': '공식 서비스',
  'pages.agentSetting.mcp.officialServices.placeholder': '공식 서비스 선택',
  'pages.agentSetting.mcp.services.weather': '날씨',
  'pages.agentSetting.mcp.services.joke': '농담',
  'pages.agentSetting.mcp.services.music': '음악',
  'pages.agentSetting.mcp.services.news': '뉴스',
  'pages.agentSetting.mcp.error.missingId': '에이전트 ID가 없어 엔드포인트를 가져올 수 없습니다',
  'pages.agentSetting.mcp.error.noEndpoint': '서버에서 엔드포인트를 가져올 수 없습니다',
'pages.agentSetting.mcp.error.fetchFailed': '엔드포인트 가져오기 실패',
  'pages.agentSetting.mcp.button.getEndpoint': 'MCP 엔드포인트 가져오기',

  // Memory settings
  'pages.agentSetting.memory.title': '단기 메모리',
  'pages.agentSetting.memory.type.label': '메모리 유형',
  'pages.agentSetting.memory.type.none': '메모리 없음',
  'pages.agentSetting.memory.type.shortTerm': '단기 메모리',
  'pages.agentSetting.memory.current.label.short': '현재 메모리',
  'pages.agentSetting.memory.current.help': '대화마다 다시 생성됨',
  'pages.agentSetting.memory.clear': '메모리 지우기',
  'pages.agentSetting.memory.clear.tip': '메모리가 지워지도록 표시되었습니다. 적용하려면 저장을 클릭하세요',
  'pages.agentSetting.memory.content.label': '메모리 내용',
  'pages.agentSetting.memory.content.placeholder': '에이전트의 최신 단기 메모리 콘텐츠 가져오기',
  'pages.agentSetting.memory.content.editPlaceholder': '메모리 내용을 입력하세요',
  'pages.agentSetting.memory.edit': '메모리 편집',
  'pages.agentSetting.memory.edit.success': '메모리가 업데이트되었습니다. 적용하려면 저장하세요',
  'pages.agentSetting.memory.edit.save': '변경 사항 저장',
  'pages.agentSetting.memory.edit.cancel': '취소',

  // 공통 버튼 및 작업
  'pages.common.cancel': '취소',

  // 시스템 구성
  'pages.admin.systemConfig.roleName': '역할 이름',
  'pages.admin.systemConfig.roleDesc': '역할 설명',
  'pages.admin.systemConfig.enabled': '활성 상태',
  'pages.admin.systemConfig.featureName': '기능 이름',
  'pages.admin.systemConfig.featureDesc': '기능 설명',
  'pages.admin.systemConfig.exitCommand': '종료 명령',
  'pages.admin.systemConfig.mcpName': 'MCP 이름',
  'pages.admin.systemConfig.newNameOptional': '새 이름 (선택 사항)',
  'pages.admin.systemConfig.configJson': '구성 JSON',
  'pages.admin.systemConfig.useDeviceCode': '장치 코드 사용',
  'pages.admin.systemConfig.quickReply': '빠른 답변',
  'pages.admin.systemConfig.shortTermMemory': '단기 메모리',
  'pages.admin.systemConfig.saveUserAudio': '사용자 오디오 파일 저장',
  'pages.admin.systemConfig.enableWhiteList': '화이트리스트 활성화',
  'pages.admin.systemConfig.speakerDetect': '화자 인식',
  'pages.admin.systemConfig.recorderManagerEnable': '레코더 관리 활성화',
  'pages.admin.systemConfig.voiceCloneEnable': '음성 복제 활성화',
  'pages.admin.systemConfig.flattenedChatHistory': '평탄화된 채팅 기록',
  'pages.admin.systemConfig.dialogueHistoryLength': '대화 기록 길이',
  'pages.admin.systemConfig.userTotalQuota': '사용자 총 할당량',
  'pages.admin.systemConfig.dailyClearQuota': '일일 할당량 초기화',
  'pages.admin.systemConfig.checkDeviceModeImmediately': '장치 모드 즉시 확인',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': '새 등록 사용자 기본 관찰자 역할',
  'pages.admin.systemConfig.status': '활성 상태',
  'pages.admin.systemConfig.port': '포트',
  'pages.admin.systemConfig.udpShowPort': '포트 표시',
  'pages.admin.systemConfig.accessToken': '액세스 토큰',
  'pages.admin.systemConfig.activateText': '활성화 텍스트',
  'pages.admin.systemConfig.logLevel': '로그 수준',
  'pages.admin.systemConfig.logDir': '로그 디렉토리',
  'pages.admin.systemConfig.logFileName': '로그 파일 이름',

  // 음성 복제 관련
  'pages.console.voiceClone.name': '이름',
  'pages.console.voiceClone.provider': '공급자',
  'pages.console.voiceClone.mode': '모드',
  'pages.console.voiceClone.record': '녹음',
  'pages.console.voiceClone.upload': '업로드',

  // 화자 인식 관련
  'pages.console.speakers.name': '이름',
  'pages.console.speakers.mode': '모드',
  'pages.console.speakers.record': '녹음',
  'pages.console.speakers.upload': '업로드',

  // 설정 페이지 관련
  'pages.console.settings.email': '이메일',
  'pages.console.settings.oldPassword': '기존 비밀번호',
  'pages.console.settings.newPassword': '새 비밀번호',
  'pages.console.settings.confirmNewPassword': '새 비밀번호 확인',

  // VLLM 공급자 관련
  'pages.providers.vllm.maxPixels': '최대 픽셀 수',
  'pages.admin.providerModal.copyAsNew': '새 공급자로 복사',

  'pages.admin.devices': '디바이스 관리',
  'pages.admin.unbindDevice': '디바이스 해제',
  'pages.admin.deviceManage': '디바이스 관리',
  'pages.systemConfig.quickReply': '빠른 답변',
  'pages.systemConfig.useShortTermMemory': '단기 기억',
  'pages.systemConfig.useShortTermMemory.desc': '활성화하면 시스템은 단기 기억 메커니즘을 사용하고 각 대화 후 단기 기억을 업데이트합니다. 비활성화하면 단기 기억이 사용되지 않습니다.',
  'pages.agentSetting.mcp.modal.show': '표시',
  'pages.agentSetting.mcp.modal.copied': '복사됨',
  'pages.agentSetting.mcp.modal.copy': '복사',
  'pages.admin.providerModal.model.label': '모델 *',
  'pages.admin.providerModal.model.placeholder': '모델명을 입력하세요',
  'pages.admin.providerModal.model.required': '모델명을 입력하세요',
  'pages.admin.providerModal.security.title': '보안 설정',
  'pages.admin.providerModal.appid.placeholder': '두바오 앱 ID',
  'pages.admin.providerModal.accessToken.placeholder': '액세스 토큰',
  'pages.admin.providerModal.grpc.addr.label': 'gRPC 주소 (호스트:포트) *',
  'pages.admin.providerModal.grpc.addr.required': 'gRPC 주소 (호스트:포트)를 입력하세요',
  'pages.admin.providerModal.token.placeholder': '두바오 토큰',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'API 키',
  'pages.admin.providerModal.manageVoices': '음성 관리',
  'pages.admin.whiteList.inputMac': 'MAC 주소를 입력하세요',
  'pages.admin.whiteList.batchAdd': '일괄 추가',
  'pages.admin.whiteList.add': '추가',
  'pages.admin.whiteList.list.title': 'MAC 주소 목록',
  'pages.admin.whiteList.selectCsvTip': 'CSV 파일을 선택하세요',
  'pages.admin.whiteList.uploadSuccess': '업로드 성공',
  'pages.admin.whiteList.uploadFailed': '업로드 실패',
  'pages.admin.whiteList.invalidMac': '유효한 MAC 주소를 입력하세요',
  'pages.admin.settings.voiceCloneEnable': '음성 클론 활성화',
  'pages.agentSetting.roleTemplate.empty': '사용 가능한 템플릿이 없습니다. role_template.json을 확인하세요',
  'pages.admin.providerModal.save': '저장',
  'pages.contractDevice.cardTitle': '계약 디바이스 관리',
  'pages.contractDevice.mac': 'MAC 주소',
  'pages.contractDevice.protocolType': '프로토콜 유형',
  'pages.contractDevice.status': '상태',
  'pages.contractDevice.expireTime': '만료 시간',
  'pages.contractDevice.updateTime': '업데이트 시간',
  'pages.contractDevice.operations': '작업',
  'pages.contractDevice.edit': '편집',
  'pages.contractDevice.delete': '삭제',
  'pages.contractDevice.deleteConfirm': '삭제 확인',
  'pages.contractDevice.addTitle': '계약 디바이스 추가',
  'pages.contractDevice.batchAddTitle': '일괄 추가',
  'pages.contractDevice.editTitle': '계약 디바이스 편집',
  'pages.contractDevice.listTitle': '계약 디바이스 목록',
  'pages.contractDevice.add': '추가',
  'pages.contractDevice.batchAdd': '일괄 추가',
  'pages.contractDevice.selectCsvTip': 'CSV 파일을 선택하세요',
  'pages.contractDevice.uploadSuccess': '업로드 성공',
  'pages.contractDevice.macRequired': 'MAC 주소를 입력하세요',
  'pages.contractDevice.protocolTypeRequired': '프로토콜 유형을 선택하세요',
  'pages.contractDevice.statusRequired': '상태를 선택하세요',
  'pages.contractDevice.expireTimeRequired': '만료 시간을 선택하세요',
};